'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingMode} from '../../core-components/loading-icon/utils';
import filterTemplate from '../../core-components/selectors/filters/projects-filter.html';
import {logger} from './logger';


ProjectsManageAssetsFilterMixin.$inject = [
  '$filter',
  'BaseFilterMixin',
  'ProjectAssetsFilterService',
];

export function ProjectsManageAssetsFilterMixin(
  $filter,
  BaseFilterMixin,
  ProjectAssetsFilterService,
) {
  return function ProjectsManageAssetsFilter(vm, $scope) {
    const baseFilter = new BaseFilterMixin($scope, {
      cacheId: 'ProjectsManageAssetsFilterMixin',
      controllerAs: 'manageAssets',
      filterTemplate: filterTemplate,
      defaultSortProperty: 'name',
      filterOptions: {
        status: {
          cancelled: true,
          has_rejections: true,
          pending: true,
          in_progress: true,
          complete: true,
        },
        showInProject: true,
        inProject: {
          yes: true,
          no: true,
        },
      },
    });

    return {
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
      addSubscription: function (sub) {
        baseFilter.activeSubscriptions.push(sub);
      },
    };

    function initFiltering(assetList, assetProjectList) {
      baseFilter.registerFilter('filteredAssetList');

      const assetList$ = assetList
        .$toObservable()
        .map($filter.toArray);

      const assetProjectFilter$ = assetProjectList
        .$toObservable()
        .map(ProjectAssetsFilterService.createAssetProjectsFilter);

      // TODO: consider adding on child added/removed listeners to remove from in-progress status

      // end to-do

      const filteredList$ = Observable.combineLatest(
        assetList$,
        baseFilter.sortOptionsObservable,
        assetProjectFilter$,
        baseFilter.filterOptionsObservable,
        baseFilter.filterObservable,
        (assetList, sortOptions, assetProjectFilter, filterOptions, autoFilter) => {
          const sortedByOptions = ProjectAssetsFilterService.sortAssetsOptions(assetList, sortOptions);
          const sortedByFilter = ProjectAssetsFilterService.sortByAssetProjects(sortedByOptions, assetProjectFilter);
          // eslint-disable-next-line max-len
          const filtered = ProjectAssetsFilterService.filterAssetsOptions(sortedByFilter, filterOptions, assetProjectFilter);
          return filterWithToString(filtered, autoFilter);
        })
        .catch(epicErrorHandler(logger, 'filteredList$'));

      // expose the filter on the view model so it can be used to conditionally style list items.
      baseFilter.activeSubscriptions.push(assetProjectFilter$.subscribe(function (assetProjectFilter) {
        vm.assetProjectFilter = assetProjectFilter;
      }));

      baseFilter.activeSubscriptions.push(updateLoadingMode(assetList$, $scope, vm));

      baseFilter.activeSubscriptions.push(
        filteredList$.subscribe(function (results) {
          $scope.$safeApply($filter.$replaceArrayContents.bind($filter, vm.filteredAssetList, results));
        })
      );


      return {
        getAssetProjectList$: () => assetProjectFilter$,
      };
    }
  };

  function filterWithToString(list, query) {
    if (!query || !isString(query)) return list;

    query = lowercase(query);

    const result = [];

    for (let i = 0, length = list.length; i < length; i++) {
      const item = list[i];

      if (item && isObject(item)) {
        if (item && lowercase(item.toString()).indexOf(query) > -1) {
          result.push(item);
        } else if (item.identifier && lowercase(item.identifier).indexOf(query) > -1) {
          result.push(item);
        }
      }
    }

    return result;
  }

  function lowercase(str) {
    return str ? str.toLowerCase() : str;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/filters/ProjectsManageAssetsFilterMixin.js